<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>

<div class="container-fluid">
  <div [hidden]="!showFilters" class="container bg-rgb mb-3 mt-4">
    <div class="flex-wrap my-2 px-3 v4-bg">
      <div class="w-100">
        <ng-container>
          <div>
            <h4 class="px-2 my-2">
              <b class="border-botom"
                ><i class="pi pi-check-square v4-ml-2"></i
                >{{ "the condition" | translator }}</b
              >
            </h4>
          </div>
          <div
            class="d-flex justify-content-center mob-my-2 v4-active-2 w-100 my-3"
          >
            <!-- <div class="w-100"> -->
            <p-selectButton
              class="v4-active-2 w-100"
              [options]="statusOptions"
              [(ngModel)]="logStatus"
              optionLabel="arabic"
              optionValue="name"
              (onChange)="this.getImpactTasksData()"
            ></p-selectButton>
            <!-- </div> -->
          </div>
        </ng-container>
      </div>

      <!-- Service Filter -->
      <div class="row d-flex my-2">
        <div class="col-md-8 col-12 my-1">
          <p-treeSelect
            class="v4-tree w-md-20rem w-100 ppp-tree-select"
            containerStyleClass="w-100"
            [(ngModel)]="oufilter"
            [options]="selectedTreeData"
            appendTo="body"
            placeholder="{{ 'Choose the organizational unit' | translator }}"
            [filter]="true"
            [filterInputAutoFocus]="true"
          >
            <ng-template let-node pTemplate="default">
              <div class="d-flex">
                <img
                  *ngIf="checkisImg(node.data); else elseBlock"
                  src="{{ staticURL }}{{ node.data }}"
                  class="img-fluid p-1 tree-img-bg"
                  style="max-height: 30px; max-width: 30px"
                />
                <ng-template #elseBlock>
                  <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                </ng-template>
                <b class="text-nowrap">{{ node.label }}</b>
              </div>
            </ng-template>
          </p-treeSelect>
        </div>
        <div class="col-md-4 col-12">
          <div class="mob-my-2">
            <ng-container>
              <button class="v4-btn-every py-2 m-1" (click)="this.getImpactTasksData()">
                <i class="pi pi-search v4-ml-2" ></i>{{ "Discuss" | translator }}
              </button>
              <button (click)="refresh()" class="v4-btn-every py-2 m-1">
                <i class="pi pi-refresh v4-ml-2"></i>{{ "Reset" | translator }}
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>

<div class="white-box container-fluid mb-5 v4-px-3">
  <div>
    <div class="grey-box">
      <div class="dynamic-table-main-tr">
        <!-- Header -->
        <div class="row f-table">
          <div class="col-md-1 col-12">
            <div class="v4-bold">#</div>
          </div>
          <div class="col-md-3 col-12">
            <div class="v4-bold">{{ "training courses" | translator }}</div>
          </div>
          <div class="col-md-3 col-12">
            <div class="v4-bold">{{ "Description" | translator }}</div>
          </div>
          <!-- <div class="col-md-2 col-12">
            <div class="v4-bold">{{ "Time" | translator }}</div>
          </div> -->
          <div class="col-md-2 col-12">
            <div class="v4-bold">{{ "Organizational units" | translator }}</div>
          </div>
          <div class="col-md-3 col-12">
            <div class="v4-bold">{{ "Date" | translator }}</div>
          </div>
        </div>
        <!-- End Header -->

        <app-no-data *ngIf="impactTasks?.length <= 0"></app-no-data>

        <ng-container *ngFor="let tasks of impactTasks; let i = index">
          <!-- Task  -->
          <ng-container>
            <div [hidden]="skelition" class="row px-2 mob-my-4">
              <div class="col-md-1 col-12 p-0 3333">
                <div class="tabel-detail-box adjustment">
                  <div (click)="toggleUsers(i)" class="d-flex">
                    <div class="ms-tabel-num-box">
                      <i class="fa fa-solid fa-chalkboard-user f-2rem-user"></i>
                    </div>
                  </div>
                  <div class="d-flex bold">{{ i + 1 }}</div>
                </div>
              </div>

              <div class="col-md-3 col-12 p-0">
                <div class="tabel-detail-box">
                  <div class="tab-scroll">{{ tasks?.title }}</div>
                </div>
              </div>
              <div class="col-md-3 col-12 p-0">
                <div class="tabel-detail-box">
                  <div class="tab-scroll">{{ tasks?.description }}</div>
                </div>
              </div>
              <div class="col-md-2 col-12 p-0">
                <div class="tabel-detail-box">
                  <div class="tab-scroll">
                    {{ getNamesString(tasks?.ous) }}
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12 p-0">
                <div class="tabel-detail-box">
                  <div class="tab-scroll d-flex align-items-center">
                    <!--  -->
                    <div>
                      {{ tasks?.end_date | date }}
                    </div>
                    <div class="d-flex align-items-center mx-2">
                      <i class="full-stop"></i>
                      <div class="time-bar"></div>
                      <i class="pi pi-arrow-left icon-purple"></i>
                    </div>
                    <div>
                      {{ tasks?.start_date | date }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p-overlayPanel
              class="v4-p-overlay-panel"
              [style]="{ width: '500px' }"
              #op
            >
              <app-training-timeline [isToolTip]="true"></app-training-timeline>
            </p-overlayPanel>
          </ng-container>
          <!-- End Training  -->

          <!-- Training Program -->
          <ng-container *ngIf="showUsers[i] && tasks?.users?.length > 0">
            <div [hidden]="skelition" class="folder-open">
              <div class="" *ngFor="let users of tasks.users; let j = index">
                <div class="row p-0">
                  <div class="col-md-1 col-12 p-0 1111">
                    <div class="tabel-detail-box adjustment">
                      <div class="d-flex">
                        <div data-label="#" class="ms-tabel-num-box">
                          <i class="fa-solid fa-user"></i>
                        </div>
                      </div>
                      <div class="d-flex bold">{{ j + 1 }}</div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 p-0">
                    <div class="tabel-detail-box">
                      <div data-label="la wasuf" class="tab-scroll">
                        {{ users.name.first }} {{ users.name.middle }}
                        {{ users.name.last }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 p-0">
                    <div class="tabel-detail-box">
                      <div
                        class="tab-scroll d-flex justify-content-center flex-wrap align-items-center"
                      >
                        {{ users.email }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-12 p-0">
                    <div class="tabel-detail-box">
                      <div
                        class="tab-scroll d-flex flex-wrap align-items-center"

                      >
                        <a
                          class="invite-btn"
                          *ngIf="users?.survey.length == 0 ;else tick"
                          (click)="navigateToUrl({courseId : tasks._id, surveyID : tasks.surveyId , userId : users._id })"
                          >{{ "Start" | translator }}
                        </a>
                        <ng-template #tick>
                          <i class="pi pi-check"></i>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- extra single section end -->
            </div>
          </ng-container>
          <!-- End Training Program -->
        </ng-container>
      </div>
    </div>
    <div class="flex justify-content-center">
      <p-paginator [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
    </div>
  </div>
</div>

<app-footer></app-footer>